import { useEffect, useState } from "react";
import { GetTableListAPI } from "../../apiCaller/getAPIsCaller";
import MaterialTable from "../../components/customTable/MaterialTable"
import { data } from "autoprefixer";
import PaginationComponent from "../../components/pagination";

const AdminGeneralTable = ({
  caller,
  tableInfo,
  mapper,
  deleteFunc,
  deleteLoading,
  updateSchema,
  updateUiSchema,
  updateSubmitFunc,
  route,
  allowImageUpload,
  imageSchema,
  imageUiSchema,
  handleImageUpload,
  allowImageManagement,
  allowPricieTiering,
  priceSchema,
  priceUiSchema,
  handlePriceUpdate,
  allowAdventureManagement,
  adventureSchema,
  adventureUiSchema,
  handleAdventureUpdate,
  title,
  subtitle
}) => {
  const [search, setSearch] = useState({ page: 1 });
  const [tableData, setTableData] = useState([]);
  const {
    data: jobList,
    error,
    isLoading,
    isFetching,
  } = GetTableListAPI(search, caller);

  useEffect(() => {
    if (mapper !== undefined) {
      setTableData(mapper(jobList));
    }
  }, [jobList]);

  const handlePageClick = (page) => {
    const newSearch = { ...search, page: page + 1 };
    setSearch(newSearch);
  };

  return (
    <div>
      <div>
        <MaterialTable
          columns={tableInfo.columns}
          rows={tableData}
          deleteFunc={deleteFunc}
          deleteLoading={deleteLoading}
          updateSchema={updateSchema}
          updateUiSchema={updateUiSchema}
          updateSubmitFunc={updateSubmitFunc}
          route={route}
          allowImageUpload={allowImageUpload}
          imageSchema={imageSchema}
          imageUiSchema={imageUiSchema}
          handleImageUpload={handleImageUpload}
          allowImageManagement={allowImageManagement}
          title={title}
          subtitle={subtitle}
          allowPriceTiering={allowPricieTiering}
          priceSchema={priceSchema}
          priceUiSchema={priceUiSchema}
          handlePriceUpdate={handlePriceUpdate}
          allowAdventureManagement={allowAdventureManagement}
          adventureSchema={adventureSchema}
          adventureUiSchema={adventureUiSchema}
          handleAdventureUpdate={handleAdventureUpdate}
        />
      </div>

      <div>
        <PaginationComponent
          totalItems={jobList?.totalItems}
          pageCount={jobList?.totalPages}
          handlePageClick={handlePageClick}
        />
      </div>
    </div>
  );
};

export default AdminGeneralTable